export const alfaMetricsConfig = {
    OPEN_LANDING: {
        category: 'Onboarding',
        label: 'Landing Screen',
        action: 'Load',
        deviceScreenName: 'Landing',
        dimensions: undefined,
    },
};

/* eslint-disable @typescript-eslint/no-empty-interface */
declare module '@alfa-bank/newclick-alfa-metrics/config-type' {
    type AnalyticsConfigType = typeof alfaMetricsConfig;
    interface AlfaMetricsEventsConfig extends AnalyticsConfigType {}
}
